import { Button, DatePicker, Pagination, Select, Table } from 'antd';
import './ctable.styles.scss'

import React, { useEffect, useState } from 'react'
import { ColumnsType } from 'antd/lib/table';
import Input from 'antd/lib/input/Input';
const { RangePicker } = DatePicker;

interface CTableProps {
    tableMainTitle?: string;
    allowTextSearch?: boolean;
    allowDateRangeSearch?: boolean;
    allowSelectBox?: boolean;
    allowAddObject?: boolean;
    selectBoxData?: any;
    selectBoxPlaceholder?: string;
    titleOfColumnList?: ColumnsType<any>;
    data?: any[];
    allowActionDetail?: boolean;
    allowActionBlock?: boolean;
    totalRecord: number;
    titleAddButton?: string;
    pageSize?: number;
    textSearch?: string;
    size?: number;
    loading?: boolean;
    rowSelection?: any;
    extraHeaderContent?: React.ReactNode;
    onChangeInput?: (event: any) => void;
    onChangeRangePicker?: (event: any) => void;
    onChangeSelectBox?: (event: any) => void;
    onSearch?: () => void;
    onChangePagination: (event: any) => void;
    handleAddObject?: () => void;
}

const CTable = (props: CTableProps) => {
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [props.totalRecord]);

    const pageSize = props.pageSize || 10;
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, props.totalRecord);

    return (
        <div className='table-main'>
            <div className='title-and-search'>
                {(props.totalRecord && props.tableMainTitle) ?
                    <div className='title'>{`${props.tableMainTitle} (${props.totalRecord})`}</div>
                    :
                    <div className='title'>{`${props.tableMainTitle}`}</div>
                }
                <div className='search-area'>
                    {
                        props.allowTextSearch &&
                        <Input onChange={
                            (event) => {
                                if (props.onChangeInput) props.onChangeInput(event)
                            }
                        }
                            placeholder={`${props.textSearch}`} />
                    }
                    {
                        (
                            props.allowTextSearch) &&
                        <Button
                            onClick={() => {
                                if (props.onSearch) props.onSearch()
                            }}
                        >Tìm kiếm</Button>
                    }
                    {
                        props.allowAddObject &&
                        <Button style={{ backgroundColor: '#10b981', color: 'white' }} onClick={props.handleAddObject}>{props.titleAddButton}</Button>
                    }
                    {props.extraHeaderContent}
                </div>
            </div>
            <div className='table-scroll'>
                <Table
                    loading={props.loading}
                    columns={props.titleOfColumnList}
                    dataSource={props.data}
                    rowSelection={props.rowSelection}
                    pagination={false}
                />
            </div>
            <div className='table-pagination'>
                <Pagination
                    current={currentPage}
                    total={props.totalRecord}
                    pageSize={pageSize}
                    showTotal={(total) => `${start}-${end} / ${total}`}
                    onChange={(page) => {
                        setCurrentPage(page);
                        props.onChangePagination(page);
                    }}
                />
            </div>
        </div>
    )
}

export default CTable
